"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const Client_1 = require("../Client");
function useMutation(mutation, options) {
    const gqlQuery = Client_1.stringToGQL(mutation);
    const update = options === null || options === void 0 ? void 0 : options.update;
    const [mutate, _a] = client_1.useMutation(gqlQuery, Object.assign(Object.assign({}, options), (update
        ? {
            update: (cache, _a) => {
                var { data } = _a, mutationResult = tslib_1.__rest(_a, ["data"]);
                return update(cache, Object.assign({ data: Client_1.extractGqlData(data) }, mutationResult));
            },
        }
        : undefined))), { error, data } = _a, result = tslib_1.__rest(_a, ["error", "data"]);
    return Object.assign({ mutate: (options) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _b = yield mutate(options), { data } = _b, result = tslib_1.__rest(_b, ["data"]);
            return Object.assign(Object.assign({}, result), { data: Client_1.extractGqlData(data) });
        }), data: result.called && !result.loading && !error ? Client_1.extractGqlData(data) : undefined, error: error ? error : undefined }, result);
}
exports.useMutation = useMutation;
//# sourceMappingURL=useMutation.js.map